import { Model, belongsTo } from 'miragejs'

export default Model.extend({
  partner: belongsTo(),
})
